//userAgent
var ua = navigator.userAgent;
var breakpoint = window.matchMedia("(max-width: 767px)");
var $images = $('.js-image-switch');
var sp = '_sp.';
var pc = '_pc.';

//userAgent デバイス判定
var _ua = (function(u){
  return {
    isTablet:(u.indexOf("windows") != -1 && u.indexOf("touch") != -1 && u.indexOf("tablet pc") == -1)
      || u.indexOf("ipad") != -1
      || (u.indexOf("android") != -1 && u.indexOf("mobile") == -1)
      || (u.indexOf("firefox") != -1 && u.indexOf("tablet") != -1)
      || u.indexOf("kindle") != -1
      || u.indexOf("silk") != -1
      || u.indexOf("playbook") != -1,
    isMobile:(u.indexOf("windows") != -1 && u.indexOf("phone") != -1)
      || u.indexOf("iphone") != -1
      || u.indexOf("ipod") != -1
      || (u.indexOf("android") != -1 && u.indexOf("mobile") != -1)
      || (u.indexOf("firefox") != -1 && u.indexOf("mobile") != -1)
      || u.indexOf("blackberry") != -1
  }
})(window.navigator.userAgent.toLowerCase());

//IE・Edge判定
var isEdge = false;
var userAgent = window.navigator.userAgent.toLowerCase();
if( userAgent.match(/(msie|MSIE)/) || userAgent.match(/(T|t)rident/) ) {
  var isIE = true;
  var ieVersion = userAgent.match(/((msie|MSIE)\s|rv:)([\d\.]+)/)[3];
  ieVersion = parseInt(ieVersion);
} else {
  var isIE = false;
  if(userAgent.indexOf("edge" )!= -1){
    isEdge = true;
  }
}

(function($){
  $(function(){
    //スマホメニュー
    spmenu();

    //iOS リンクのダブルタップバグ
    if(/iPhone|iPad|iPod/.test(ua)) {
      $("body").addClass("_ios");
    }

    //PCのとき 電話番号 無効
    if(!_ua.isMobile){
      $(".-telink").on('click', function(){
        return false;
      });
    }

    //スムーズスクロール
    if(location.href.indexOf("file")==0){
      var url = "file://" + location.hostname + location.pathname + location.search;
    }else if(location.href.indexOf("https")==0){
      var url = "https://" + location.hostname + location.pathname + location.search;
    }else{
      var url = "http://" + location.hostname + location.pathname + location.search;
    }
    $("a[href*='#'],area[href*='#']").not('.popup').not('.password-recover').on('click', function() {
      var id = this.href.substring(this.href.indexOf('#'),this.href.length);
      var hrefUrl = this.href.split(id);
      if(String(hrefUrl[0]) == String(url)) {
        var hash = this.hash;
        if(!hash || hash == "#") {
          return false;
        }else if(id == '#inbox') {
          $('html, body').animate({scrollTop: 0}, 1000, "swing");
          return false;
        }else if(id != "#"){
          $('html, body').animate({scrollTop: $(hash).offset().top - $("#shopify-section-header_custom").height()}, 1000, "swing");
          return false;
        }
      }
    });

    //アコーディオン
    $('.ac-body').hide();
	  $(".ac-head").on('click',function(){
      var $target = $(this);
	    $target.toggleClass('-open').next('.ac-body').slideToggle(400);
    });

    // resize
    //$(window).on('resize', function () {
    //  // resize check exec
    //  if (resizeTimer !== false) {
    //    clearTimeout(resizeTimer);
    //  }
    //  resizeTimer = setTimeout(function() {
    //    checkWindowSize();
    //  }, 200);
    //});

    // メインビジュアル
    var mvSlider = new Swiper('.mv-container',{
      freeMode: false,
      // slidesPerView: 2.05,
      // noSwiping: true,
      simulateTouch: false,
      centeredSlides: true,
      speed: 1000,
      loop: true,
      loopAdditionalSlides: 1,
      spaceBetween: 20,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      // breakpoints:{
      //   1600:{
      //     slidesPerView: 1.75,
      //   },
      //   1366:{
      //     slidesPerView: 1.5,
      //   }
      // }
    });
    //再生・停止
    $(".swiper-pause").on("click", function() {
      if ($(this).hasClass("-paused")) {
        mvSlider.autoplay.start(); // 再生
        $(this).removeClass("-paused"); // .paused 削除
      } else {
        mvSlider.autoplay.stop(); // 一時停止
        $(this).addClass("-paused"); // .paused 付与
      }
    });

    //子どもたちからのお手紙
    var letterSlider = new Swiper('.letter-container',{
      loop: true,
      spaceBetween: 100,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

    // TOPページ商品コンテンツ
    var topproduct = new Swiper('.mediacontent',{
      freeMode: false,
      direction: "vertical",
      slidesPerView: 1,
      // noSwiping: true,
      speed: 1000,
      loop: true,
      loopAdditionalSlides: 1,
      // autoplay: {
      //   delay: 3000,
      // },
      pagination: {
        el: ".ballet",
        clickable: true,
      },
    });

    $('.popup-area .popup').magnificPopup({
      type: "inline",
      mainClass: "top-productdesc",
      preloader: false,
      fixedContentPos: true,
      alignTop: false,
    });

    $('.mfp-guide').magnificPopup({
      type: "inline",
      mainClass: "product-sizeguide",
      preloader: false,
      fixedContentPos: true,
      alignTop: false,
      callbacks: {
        open: function() {
          miniContent();
          closeBtn();
        },
      },
    });
    function miniContent(){
      if($('.product-sizeguide #sizeguide').hasClass('-mini')){
        $('.product-sizeguide .mfp-content').addClass('-mini');
      }
    }
    function closeBtn(){
      $('.product-sizeguide .close-btn').on('click',function(){
        $('.mfp-guide').magnificPopup('close');
      });
    }

    var hh = $('.l-header .header-inner').height();
    var mvh = $('.shopify-section.main-visual').height();
    var hhplus = hh + 20;
    var topH = hh + mvh;
    $(window).on('load scroll', function(){
      if(mvh == null){
        if($(window).scrollTop() > hhplus){
          $('.l-header').addClass('-kotei');
        }else if($(window).scrollTop() < hhplus){
          $('.l-header').removeClass('-kotei');
        }  
      }else{
        if($(window).scrollTop() > hh && $(window).scrollTop() < topH && $(window) > 768){
          $('.l-header').addClass('-zero');
        }else if($(window).scrollTop() < hh && $(window).scrollTop() < topH && $(window) > 768){
          $('.l-header').removeClass('-zero');
        }
        if($(window).scrollTop() > topH){
          $('.l-header').addClass('-kotei');
        }else if($(window).scrollTop() < topH){
          $('.l-header').removeClass('-kotei');
        }
      }
    });

    // TOPページお客様の声
    var voices = new Swiper('.customer-voice',{
      freeMode: false,
      slidesPerView: 1,
      noSwiping: true,
      speed: 1000,
      loop: true,
      loopAdditionalSlides: 1,
      simulateTouch: false,
      navigation:{
        nextEl: '.next-btn',
      },
      // autoplay: {
      //   delay: 3000,
      // },
    });

    //商品ページメディア
    var mediabullet = new Swiper('.media-slider-bullet',{
      slidesPerView: '20',
      freeMode: false,
      watchSlidesProgress: true,
    });
    var mediaslider = new Swiper('.media-slider',{
      effect: 'fade',
      freeMode: false,
      slidesPerView: 1,
      speed: 400,
      loop: true,
      noSwiping: true,
      loopAdditionalSlides: 1,
      thumbs:{
        swiper: mediabullet
      },
      // pagination: {
      //   el: ".ballet",
      //   clickable: true,
      // },
    });

    document.querySelectorAll('.product-area').forEach((area) => {
      const swiperContainer = area.querySelector('.swiper._view-md-low.popup-area');
      const pagination = area.querySelector('.product-pagination');
      const prevButton = area.querySelector('.product.prev-bullet');
      const nextButton = area.querySelector('.product.next-bullet');

      new Swiper(swiperContainer, {
        slidesPerView: 2,
        speed: 800,
        spaceBetween: 16,
        navigation: {
          prevEl: prevButton,
          nextEl: nextButton,
        },
        pagination: {
          el: pagination,
          type: 'bullets',
          clickable: true,
        }
      });
    });

    //商品一覧
    var collectionListslider = new Swiper('.collectionList-slider',{
      spaceBetween: 16,
      slidesPerView: 1.2,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        767:{
          spaceBetween: 32,
          slidesPerView: 4,
          // centeredSlides: true,
        }
      }
    });

    $('.fixed-content .closebtn').on('click',function(){
      $('.fixed-content').fadeOut();
    });

    // 会員登録
    function sei(){
      var def = $.Deferred();
      if($('.field #RegisterForm-FirstName').val() == ""){
        $('.error-form-txt.mei').fadeIn();
      }else if($('.field #RegisterForm-FirstName').val() != ""){
        $('.error-form-txt.mei').fadeOut();
      }else{}
      return def.promise();
    }

    function mei(){
      var def = $.Deferred();
      if($('.field #RegisterForm-LastName').val() == ""){
        $('.error-form-txt.sei').fadeIn();
      }else if($('.field #RegisterForm-LastName').val() != ""){
        $('.error-form-txt.sei').fadeOut();
      }else{}
      return def.promise();
    }

    function furigana(){
      var def = $.Deferred();
      if($('.field #RegisterForm-furigana').val() == ""){
        $('.error-form-txt.furigana').fadeIn();
      }else if($('.field #RegisterForm-furigana').val() != ""){
        $('.error-form-txt.furigana').fadeOut();
      }else{}
      return def.promise();
    }

    function email(){
      var def = $.Deferred();
      if($('.field #RegisterForm-email').val() == ""){
        $('.error-form-txt.email').fadeIn();
      }else if($('.field #RegisterForm-email').val() != ""){
        $('.error-form-txt.email').fadeOut();
      }else{}
      return def.promise();
    }

    function password(){
      var def = $.Deferred();
      if($('.field #RegisterForm-password').val() == ""){
        $('.error-form-txt.pass').fadeIn();
      }else if($('.field #RegisterForm-password').val() != ""){
        $('.error-form-txt.pass').fadeOut();
      }else{}
      return def.promise();
    }

    //LPお客様の声
    var lpvoices = new Swiper('.lp-voice',{
      freeMode: false,
      slidesPerView: 1,
      noSwiping: true,
      speed: 1000,
      loop: false,
      simulateTouch: false,
      spaceBetween: 10,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + "</span>";
        },
        renderBullet: false,
      },
      navigation:{
        nextEl: '.next-btn',
        prevEl: '.prev-btn',
      },
      breakpoints: {
        768:{
          pagination: {
            renderBullet: true,
          },
        }
      }
    });

    $('#create_customer button').on('click',function(){
        $.when(sei(), mei(), furigana(),email(),password());
        if($('.field #RegisterForm-FirstName').val() != "" && $('.field #RegisterForm-LastName').val() != "" && $('.field #RegisterForm-furigana').val() != "" && $('.field #RegisterForm-email').val() != "" && $('.field #RegisterForm-password').val() != ""){
        }else{
          return false;
        }
    });
    //LP スマホメニュー表示切替
    $('.lp-navigationButton').on('click',function(){
      $(this).toggleClass('-open');
      if($(this).hasClass('-open')){
        $('.l-lp-header').css('height','65px');
        $('.l-lp-header .sp-navigation').fadeIn(300).css({"height":$(window).innerHeight(),"min-height":$(window).innerHeight()});
        $('body').addClass('-fixed');
      }else{
        $('.l-lp-header').css('height','90px');
        $('.l-lp-header .sp-navigation').fadeOut(300);
        $('body').removeClass('-fixed');
      }
    });
    var lpnavID = $('.navigation-list').children().children()
    lpnavID.on('click',function(){
      if($('.lp-navigationButton').hasClass('-open')){
        $('.l-lp-header').css('height','90px');
        $('.l-lp-header .sp-navigation').fadeOut(300);
        $('body').removeClass('-fixed');
        $('.lp-navigationButton').removeClass('-open');
      }else{
      }
    });

    //LP固定ボタン
    var lpHsize = $('.l-lp-header').height();
    var lpMVsize = $('.section-landingpage .l-main-visual').height();
    var lpSHOWH = lpHsize + lpMVsize;
    var lpFsize = $('.l-lp-footer').innerHeight();
    var lpHIDEF = $(document).height() - ($(window).height() + lpFsize);
    $(window).on('scroll',function(){
      if($(this).scrollTop() > lpHIDEF | $(this).scrollTop() < lpSHOWH){
        $('.lp-fixed-btn').fadeOut(400);
      }else if($(this).scrollTop() > lpSHOWH){
        $('.lp-fixed-btn').fadeIn(400);
      }
    })

    //商品カラー選択で画像を切り替え
    $(document).on('change','.pg-product select[name="options[カラー]"]',function(){
      let color = $(this).val();
      let slideNum = $('.media-slider-bullet .swiper-slide img[alt="'+ color +'"]').index('.media-slider-bullet .swiper-slide img');
      mediaslider.slideTo(slideNum + 2);
    })
  });

  $(window).on('load resize',function(){
    //lpの商品ラインナップ部分
    if($(window).width() < 990){
      var lplineup = new Swiper('.lp-lineup',{
        freeMode: false,
        slidesPerView: 1,
        noSwiping: true,
        speed: 500,
        loop: false,
        simulateTouch: false,
        spaceBetween: 10,
        navigation:{
          nextEl: '.lineup-next',
          prevEl: '.lineup-prev',
        },  
      });
    }else{
    }
  });

  //お客様の声タブ
  $(document).ready(function () {
    $('.l-voice-tab .tab').on('click', function () {
      // 現在のタブをアクティブにする
      $('.l-voice-tab .tab').removeClass('-active');
      $(this).addClass('-active');

      const target = $(this).data('target');
      $('.voice-tab-contents').hide();
      $(`.voice-tab-contents[data-target="${target}"]`).show();
    });
  });


  //スマホメニュー
  var menuState = false;
  var menuPos;
  function spmenu() {
    var menu = $('#sp-nav'),
        menuBtn = $('#js-menuButton');

    // open
    menuBtn.on('click', function(){
      $(this).toggleClass("-open");
      if(menuState == false) { // スクロールを無効
        menu.stop().fadeIn(300);
        menuPos = $(window).scrollTop();
        $('body').addClass('-fixed').css({'top': -menuPos});
        $('.cart-button,.splogo').addClass('-open');
        menuState = true;
      } else {
        menu.stop().hide();
        $('body').removeClass('-fixed').css({'top': 0});
        window.scrollTo(0, menuPos );
        menuState = false;
        $('.cart-button,.splogo').removeClass('-open');
      }
    });
  }

  // $('.pg-register button').on('click',function(){
  // });

  // resize check exec
  //var resizeTimer = false;
  //function checkWindowSize(){
  //  var windowW = $(window).width();
  //  if(windowW > 960 ){
  //    $("").each(function() {
  //      $(this).find("li").tile(3);
  //    });
  //  } else {
  //    $("").find("li").height("auto");
  //  }
  //}

  // $.ajax({
  //   type: 'GET',
  //   url: 'https://graph.facebook.com/v14.0/17841454849544898?fields=name%2Cmedia.limit(16)%7Bcaption%2Clike_count%2Cthumbnail_url%2Cmedia_url%2Cpermalink%2Ctimestamp%2Cusername%7D&access_token=EAAVpUskMLdMBAC56bJfIMb8qklR6Im8Cc5pfD0mMHcbhxq3rpVCzxTDNeP6tApe6ZAiH26WaUMswUQOqYPklKRdyVqUGkdbVqlZAHRyN2g1ijMZCfyWGPDIlW3j0lH9Qkhd4XZCpGpZCzum2PUtzhUohxxsRaEwBcDzapgXdoMFXdZC4QkzIbM',
  //   dataType: 'json',
  //   success: function(json) {
  //     var html = '';
  //     var insta = json.media.data;
  //     for (var i = 0; i < insta.length; i++) {
  //         var image;
  //         if (!insta[i].thumbnail_url) {
  //           // 動画の場合はこちら
  //           image = insta[i].media_url;
  //         } else {
  //           // 写真の場合はこちら
  //           image = insta[i].thumbnail_url;
  //         } 
  //         html += '<li class="swiper-slide"><a href="' + insta[i].permalink + '" target="_blank"><img src="' +  image  + '"></a></li>';
  //     }
  //     $(".insta-slider").append(html); 
  //     timedulatiuon(300);
  //   },
  //   error: function() {  }
  // });

  setTimeout(function(){
    $('.globo-form-control >textarea').parents().addClass('textarea');
  },1000);

})(jQuery);